import React from "react"
import BlurBackground, {
  BlurBackgroundProps,
} from "./BlurBackground/BlurBackground"
import elementSplitter from "./utils/elementSplitter"
import Content from "./Content/Content"
import Section from "./Section/Section"

type WidgetCenterElementProps = {
  children: React.ReactElement
  topSpace?: number | string
  gap?: number
  backgroundType: BlurBackgroundProps["type"]
}

const WidgetCenterElement = ({
  children,
  topSpace = 100,
  gap = 70,
  backgroundType,
}: WidgetCenterElementProps) => {
  //
  const { headers, paragraphs, components, svgs } = elementSplitter(children)

  // Decorative SVG
  const decorativeSVG = svgs[0] && (
    <>
      {svgs[1] ? (
        <>
          {React.cloneElement(svgs[0] as React.ReactElement, {
            style: { ...svgs[0].props.style, width: "50px", marginTop: "30px" },
          })}
          {React.cloneElement(svgs[1] as React.ReactElement, {
            style: { ...svgs[1].props.style, width: "16px" },
          })}
        </>
      ) : (
        React.cloneElement(svgs[0] as React.ReactElement, {
          style: { ...svgs[0].props.style, width: "50px", marginTop: "30px" },
        })
      )}
    </>
  )

  const firstChild =
    React.Children.count(children) > 0 && React.Children.toArray(children)[0]
  const isFirstChildOfFunction =
    React.isValidElement(firstChild) && typeof firstChild.type === "function"

  return (
    <Content rows={3} gap={gap} topSpace={topSpace} autoSize>
      {isFirstChildOfFunction ? (
        <>
          <Section>{components[0]} </Section>

          <Section y="top" style={{ textAlign: "center" }}>
            {headers}
            {paragraphs}
            {components.slice(1, -1)}
            {decorativeSVG}
            {components.slice(-1)[0]}
          </Section>
        </>
      ) : (
        <>
          <Section y="top" style={{ textAlign: "center" }}>
            {headers}
            {paragraphs}
          </Section>

          <Section>{components[0]}</Section>

          <Section>
            {components.slice(1)}
            {decorativeSVG}
          </Section>
        </>
      )}

      {backgroundType && (
        <BlurBackground direction="center" type={backgroundType} />
      )}
    </Content>
  )
}

export default WidgetCenterElement
